import {
  BasketballResultId,
  CommonResultId,
} from '@collector/sportsapi-client-legacy'

import { ResultIdsSet } from '../../ParticipantsDataTable/ResultIdsSet'
import { StatIdsSet } from '../../ParticipantsDataTable/StatIdsSet'
import { VerifyResultsSportFactory } from './VerifyResultsSportFactory'

export function verifyResultsBasketballFactory(): VerifyResultsSportFactory {
  function getResultsIdsSet(): ResultIdsSet {
    return new ResultIdsSet([
      CommonResultId.Result,
      CommonResultId.RegularTime,
      BasketballResultId.FirstHalf,
      BasketballResultId.SecondHalf,
      BasketballResultId.FirstQuarter,
      BasketballResultId.SecondQuarter,
      BasketballResultId.ThirdQuarter,
      BasketballResultId.FourthQuarter,
      BasketballResultId.Overtime,
    ])
  }

  function getStatIdsSet(): StatIdsSet {
    return new StatIdsSet([])
  }

  return {
    getResultsIdsSet,
    getStatIdsSet,
  }
}
